// import { useVisibilityChange } from "@uidotdev/usehooks";
// import { setupNotifications } from "config/firebase";
// import { saveFMAtoken } from "features/user/api";
// import { useEffect } from "react";
import { Navigate, Outlet } from "react-router-dom";
// import useSWRMutation from "swr/mutation";
// navigator.permissions
//   .query({ name: "notifications" })
//   .then((permissionStatus) => {
//     console.log("Initial state:", permissionStatus.state);

//     permissionStatus.onchange = () => {
//       console.log("Permission changed to:", permissionStatus.state);
//     };
//   });

const AppLayout = () => {
  // const isForeground = useVisibilityChange();
  // const FCMtoken = localStorage.getItem("FCMtoken");
  const token = localStorage.getItem("userToken");

  // const { trigger, isMutating, data, error } = useSWRMutation(
  //   "/mobile-device",
  //   (_, { arg }) => saveFMAtoken(arg)
  // );

  // useEffect(() => {
  //   console.log("Checking Notification permission status...");
  //   if ("permissions" in navigator) {
  //     navigator.permissions
  //       .query({ name: "notifications" })
  //       .then((permissionStatus) => {
  //         console.log("Initial state:", permissionStatus.state);

  //         permissionStatus.onchange = () => {
  //           console.log("Permission changed to:", permissionStatus.state);
  //           // You can re-call setupNotifications or handle changes here
  //         };
  //       });
  //   }
  // }, []);
  // console.log("permissionStatus -- ", Notification.permission);
  // console.log(window);
  // useEffect(() => {
  //   console.log("firebase useeffect");
  //   if (token) {
  //     setupNotifications((message) => {
  //       console.log("MESSAGE", message);

  //       if (isForeground) {
  //         // App is in the foreground, show toast notification
  //         // toastNotification({
  //         //   title : '',
  //         //   description: body,
  //         //   status: "info",
  //         // });
  //         console.log("foreground");
  //       } else {
  //         console.log("background");
  //         // App is in the background, show native notification
  //         // sendNativeNotification({
  //         //   title,
  //         //   body,
  //         // });
  //       }
  //     });
  //   }
  //   if (FCMtoken) {
  //     console.log(777);
  //     // trigger(FCMtoken);
  //   }
  // }, [isForeground]);

  return token ? <Outlet /> : <Navigate to="/login" />;
};

export default AppLayout;
